(() => {
  const initGallery = (gallery) => {
    const track = gallery.querySelector('.pdp-acne-kit__track');
    const dots = Array.from(gallery.querySelectorAll('.pdp-acne-kit__dot'));
    if (!track || dots.length < 2) return;

    const setActive = (idx) => {
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
    };

    track.addEventListener('scroll', () => {
      const idx = Math.round(track.scrollLeft / track.clientWidth);
      setActive(idx);
    }, { passive: true });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });
  };

  const init = (root) => {
    (root || document).querySelectorAll('.pdp-acne-kit__gallery').forEach(initGallery);
  };

  if (document.readyState !== 'loading') {
    init(document);
  } else {
    document.addEventListener('DOMContentLoaded', () => init(document));
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
